<script>
import { mapGetters } from 'vuex'

export default {
    name: 'header',

    computed:
    {
        ...mapGetters({
            locales: 'locales',
            locale: 'locale',
        })
    },
}
</script>

<template lang="pug">
    .justfit-header.nopad
        .container.nopad
            .d-flex.justify-content-between.align-items-center
                justfit-image.logo(:src="require(`@/assets/img/logo.png`)" alt="Justfit")
                .d-flex.justify-content-start.align-items-center.menu
                    justfit-image.d-flex.align-items-center(:src="require(`@/assets/img/right.png`)" alt="languages")
                    button.btn.btn-transparent(
                        :class="{'active': loc == locale}"
                        v-for="loc in locales" :key="loc" 
                        @click="$router.replace({ name: 'home', params: { locale: loc } })"
                    ) {{ $t(`BASE.${loc}`) }}
</template>

<style lang="scss" scoped>
    @import "../../assets/styles/settings/settings";

    .justfit-header {
        position: absolute;
        top: 0;
        left:0;
        width: 100%;
        padding: rem(8) rem(16);
        z-index: 10;
        @media(max-width: 768px)
        {
            padding-right: 0 !important;
        }
        button {
            color: $white;
            font-style: italic;
            font-weight: 700;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
        }
        button.active {
            color: $justfit-green !important;
        }
        .menu {
            background-color: rgba(0,0,0, 0.8);
            padding: 0 rem(24);
            @media(max-width: 768px)
            {
                padding: 0;
            }
        }
        .nopad {
            @media(max-width: 768px)
            {
                padding: 0 !important;
            }
        }
    }

</style>
